<template>
  <div :id="widget.object.wid" class="widget-item" :style="style">
    <link-viewer :zoom="templateScaleFactor" :data="widget.object" />
  </div>
</template>

<script>
  import LinkViewer from '@/components/apps/link/LinkViewer.vue';

  import { simpleTypeMixin } from '@/helpers';
  import templateWidget from '@/components/templates/mixins/templateWidget';

  export default {
    name: 'LinkWidget',

    components: {
      LinkViewer,
    },

    mixins: [simpleTypeMixin, templateWidget],

    props: {
      widget: {
        type: Object,
      },
    },

    data() {
      return {
        showLink: true,
        templateScaleFactor: 1,
      };
    },

    mounted() {
      this.templateScaleFactor = this.getTemplateScaleFactor;
    },

    computed: {
      getTemplateScaleFactor() {
        const layoutWidgetElement = document.getElementById(this.widget.object.item_id);
        const parentWidthRatio =
          layoutWidgetElement?.clientWidth / this.widget.position.widthPixels;

        return parentWidthRatio;
      },

      style() {
        return {
          ...this.defaultStyling(this.widget),
          overflow: 'hidden',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widget-item {
    position: absolute;
    overflow: hidden;
  }
</style>
